const config = {
    //apiEndPoint: "http://localhost:3001/",
//  apiEndPoint: "http://localhost:85/",
    apiEndPoint: "https://jwlapi.arasoftpeoplehub.com/",
    pageCount: "10"

}
export default config;